'use strict';

// require any browser shims,
// polyfills, and any other junk here.

require('./array/');


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/shim.js
 ** module id = 13
 ** module chunks = 0
 **/